export { EX3DataFeed } from './ex3/DataFeed';
export { ExampleDataFeed } from './example/DataFeed';
export { IHistoryProvider, IStreamProvider } from './interface';
